import { deleteWeavingAlert } from "../../_services/weaving_alert"

export const deleteWeavingAlertEvent = async (id) => {
    const res = await deleteWeavingAlert(id);
    if(!res.ok) throw new Error(res.error);

    return res; 
}
